// extracted by mini-css-extract-plugin
export default {"tag":"tag___lnIt6","small":"small___buc7f","delete":"delete___ClShu","row":"row___pomLk","moreText":"moreText___n3DR6","wrapper":"wrapper___OqYFu"};